///<reference path="../../../typings/angularjs/angular.d.ts"/>
///<reference path="processEditor-module.ts"/>

module ProcessEditor {
    'use strict';

    export class ProcessInstanceService {
        constructor(private $http: ng.IHttpService, private $q: ng.IQService, private processInstanceUrl: string) {}

        public getProcessInstance(executionId: string):ng.IPromise<ProcessInstance> {
            var instance = this.$q.defer<ProcessInstance>();
            this.$http.get(this.processInstanceUrl, {params: { executionId: executionId } }).success((response: Frends.IJsonResponse) => {
                if (response.success) {
                    var taskData = response.data;
                    instance.resolve(taskData);
                } else {
                    instance.reject(response.errorMessage);
                }
            }).error((error) => {
                instance.reject(error);
            });

            return instance.promise;
        }
    }

    export class ProcessInstanceStep {
        id: number;
        stepId: string;
        state: string;
        startTimeUtc: string;
        endTimeUtc: string;
        processExecutionId: string;
        parameters: any;
        result: string;
        duration: string;
    }

    export class ProcessInstance {
        executionId: string;
        processName: string;
        state: string;
        exception: string;
        startTimeUtc: string;
        endTimeUtc: string;
        duration: string;
        steps: ProcessInstanceStep[];
    }

    app.service("ProcessInstanceService", ["$http", "$q", "processInstanceUrl", ProcessInstanceService]);
}